import { getDashboardOrderDataApi } from "configs"

export const GET_DASHBOARD_ORDERS_DATA = 'GET_DASHBOARD_ORDERS_DATA'
export const getDashboardOrderData = () => async dispatch => {
  try {
    const { data } = await getDashboardOrderDataApi()
    console.log("🚀 ~ file: actions.js ~ line 7 ~ data", data)
    dispatch({ type: GET_DASHBOARD_ORDERS_DATA, payload: data })
  } catch (error) {
    console.log(error)
  }
}
